import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import { Node } from 'data/types'
import messages from 'lang'
import React, { useState } from 'react'
import Markdown from 'react-markdown'
import styled from 'styled-components'
import { color } from 'utils'

import Question from './Question'

export const Button = styled(CeruleanButton)`
  width: 100%;
  transition: all 0.2s ease-in;

  &:disabled {
    background: ${color('blue400')};
  }
`

export const QuestionWrapper = styled.div`
  display: grid;
  gap: 0.5rem;
  margin: 1rem 0;
`

export const QuestionHeader = styled.div`
  display: grid;
  gap: 0.3rem;
`
export const QuestionTitle = styled.p`
  margin: 0;
  a {
    text-decoration: none;
    font-weight: bold;
    color: ${color('blue400')};
  }
`

export const QuestionEmbeddedTitle = styled.span`
  margin: 0;
  a {
    text-decoration: none;
    font-weight: bold;
    color: ${color('blue400')};
  }
`

export const QuestionSubTitle = styled.p`
  margin: 0;
  color: ${color('grey600')};
`

const isValid = (node: Node): boolean => {
  if (node.type === 'SINGLE_SELECTION' || node.type === 'MULTIPLE_SELECTION') {
    const selectedOption = node.children.find((c) => c.checked === true)
    if (!selectedOption) return false
    if (!selectedOption.children) return true
    return !selectedOption.children.find((c) => c.input === '')
  }

  return true
}

type KYCStepProps = {
  onDone: (question: Node) => void
  question: Node
}
const KYCStep = ({ onDone, question: passedQuestion }: KYCStepProps) => {
  const [question, setQuestion] = useState<Node>(passedQuestion)

  if (question.type === 'SINGLE_CHECKBOX') {
    return (
      <>
        <QuestionWrapper>
          <Question
            question={question}
            onChange={() => setQuestion({ ...question, checked: !question.checked })}
          />
        </QuestionWrapper>
        <Button onClick={() => onDone(question)} disabled={!isValid(question)}>
          <I18n data={messages.button_next} />
        </Button>
      </>
    )
  }

  return (
    <>
      <QuestionHeader>
        <QuestionTitle>
          <Markdown linkTarget='_blank'>{question.text}</Markdown>
        </QuestionTitle>
        {['MULTIPLE_SELECTION', 'SINGLE_SELECTION'].includes(question.type) && (
          <QuestionSubTitle>
            <I18n
              data={
                question.type === 'MULTIPLE_SELECTION'
                  ? messages.select_all_that_apply
                  : messages.select_only_one
              }
            />
          </QuestionSubTitle>
        )}
      </QuestionHeader>
      <QuestionWrapper>
        <Question
          question={question}
          onChange={(nodes) => setQuestion({ ...question, children: nodes } as Node)}
        />
      </QuestionWrapper>
      <Button onClick={() => onDone(question)} disabled={!isValid(question)}>
        <I18n data={messages.button_next} />
      </Button>
    </>
  )
}

export default KYCStep
